<template>
    <div class="form-row align-items-center mb-3">
        <div class="col-auto">
            Order by
        </div>
        <div class="col-auto">
            <select class="form-control  form-control-sm"
                    v-model="selected">
                <option :value="null">SELECT...</option>
                <option v-for="(option, index) in options"
                        :key="'orderBy_' + index"
                        :value="option">
                    {{option.label}}
                </option>
            </select>
        </div>
        <div class="col-auto">
            <div class="col-auto">
                Direction
            </div>
        </div>
        <div class="col-auto">
            <select class="form-control  form-control-sm"
                    v-model="direction">
                <option :value="null">SELECT...</option>
                <option :value="'ASC'">ASC</option>
                <option :value="'DESC'">DESC</option>
            </select>
        </div>
        <div class="col-auto">
            <div class="col-auto">
                <button 
                    class="btn btn-primary btn-sm"
                        @click="handleClick">
                    Go
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'OrderBy',
        props: ['value','options'],
        mounted() {
            this.selected = this.value
        },
        data: () => {
            return {
                selected: null,
                direction: null
            }
        },
        watch: {
            'selected': function () { this.$emit('input', { orderBy: this.selected, direction: this.direction }) },
            'direction': function () { this.$emit('input', { orderBy: this.selected, direction: this.direction }) }
        },
        methods: {
            handleClick() {
                this.$emit('goClick', { orderBy: this.selected, direction: this.direction })
            }
        }
    }
</script>